// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-container .notification-success {
  background-color: var(--ts-primary) !important;
  color: var(--ts-white) !important;
}
.notification-container .notification-info {
  background-color: var(--ts-grey) !important;
  color: var(--ts-white) !important;
}
.notification-container .notification-warning {
  background-color: var(--ts-red) !important;
  color: var(--ts-white) !important;
}
.notification-container .notification-error {
  background-color: var(--ts-red) !important;
  color: var(--ts-white) !important;
}

`, "",{"version":3,"sources":["webpack://./src/theme/notifications.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,iCAAiC;AACnC;AACA;EACE,2CAA2C;EAC3C,iCAAiC;AACnC;AACA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC;AACA;EACE,0CAA0C;EAC1C,iCAAiC;AACnC","sourcesContent":[".notification-container .notification-success {\n  background-color: var(--ts-primary) !important;\n  color: var(--ts-white) !important;\n}\n.notification-container .notification-info {\n  background-color: var(--ts-grey) !important;\n  color: var(--ts-white) !important;\n}\n.notification-container .notification-warning {\n  background-color: var(--ts-red) !important;\n  color: var(--ts-white) !important;\n}\n.notification-container .notification-error {\n  background-color: var(--ts-red) !important;\n  color: var(--ts-white) !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
